import { render, staticRenderFns } from "./dashboard-empty.vue?vue&type=template&id=0eae5e1f&"
import script from "./dashboard-empty.vue.ts?vue&type=script&lang=ts&"
export * from "./dashboard-empty.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports